import {navClockSvg as Icon__small__navClockSvg} from '../Icon__small/Icon__small--navClock.js'
import {navClockSvg as Icon__xsmall__navClockSvg} from '../Icon__xsmall/Icon__xsmall--navClock.js'

export var navClock = {
  name: 'navClock',
  category: 'icon',
  colorable: true,
  svg: Icon__small__navClockSvg,
  alt: {
    Icon__small: Icon__small__navClockSvg,
    Icon__xsmall: Icon__xsmall__navClockSvg
  },
  combined: ['Icon__small', 'Icon__xsmall']
};
